module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-container"
  }, [_c('v-btn', {
    attrs: {
      "fixed": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('updateShowingModal', {
          active: true,
          name: 'addCatagory'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "input-file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.$store.state.catagories), function(item, index) {
    return _c('v-card', {
      key: index,
      staticStyle: {
        "margin": "1rem"
      },
      attrs: {
        "tile": ""
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [(_vm.editing && _vm.editingObj._id == item._id) ? _c('v-text-field', {
      staticStyle: {
        "font-family": "'DINPro Regular'"
      },
      attrs: {
        "label": "Title",
        "required": ""
      },
      model: {
        value: (_vm.newTitle),
        callback: function($$v) {
          _vm.newTitle = $$v
        },
        expression: "newTitle"
      }
    }) : _c('h3', {
      staticStyle: {
        "font-family": "'DINPro Regular'"
      },
      attrs: {
        "center": ""
      }
    }, [_vm._v(_vm._s(item.title))])], 1)]), _vm._v(" "), _c('v-img', {
      staticClass: "grey lighten-2",
      class: {
        'hover-img': _vm.editing && _vm.editingObj._id == item._id
      },
      attrs: {
        "src": item.imageUrl,
        "lazy-src": item.imageUrl,
        "aspect-ratio": "1"
      },
      on: {
        "click": function($event) {
          _vm.changeImg((_vm.editing && _vm.editingObj._id == item._id))
        }
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function() {
          return [_c('v-layout', {
            attrs: {
              "fill-height": "",
              "align-center": "",
              "justify-center": "",
              "ma-0": ""
            }
          }, [_c('v-progress-circular', {
            attrs: {
              "indeterminate": "",
              "color": "grey lighten-5"
            }
          })], 1)]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('v-card-actions', [(_vm.editing && _vm.editingObj._id == item._id) ? _c('v-btn', {
      staticStyle: {
        "font-family": "'DINPro Light'"
      },
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.setEdit(false)
        }
      }
    }, [_vm._v("cancel")]) : _c('v-btn', {
      staticStyle: {
        "font-family": "'DINPro Light'"
      },
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.setEdit(item)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), (_vm.editing && _vm.editingObj._id == item._id) ? _c('v-btn', {
      staticStyle: {
        "font-family": "'DINPro Light'"
      },
      attrs: {
        "flat": "",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          return _vm.saveEdit(item._id)
        }
      }
    }, [_vm._v("save")]) : _c('v-btn', {
      staticStyle: {
        "font-family": "'DINPro Light'"
      },
      attrs: {
        "flat": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.removeCatagory(item._id)
        }
      }
    }, [_vm._v("remove")])], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5116104a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/Catagories.vue
// module id = 217
// module chunks = 1